require('./vendor/jquery.hoverIntent');
require('./vendor/jquery.detect_swipe.js');
require('./vendor/featherlight/featherlight.min');
require('./vendor/featherlight/featherlight.gallery');

require('slick-carousel');
require('jquery-confirm');
require('./navigation.js');
require('./cookie.js');

var viewportWidth = window.innerWidth;

var allVideos;

jQuery(document).ready(function ($) {

	$.detectSwipe.enabled;

	viewportWidth = window.innerWidth;
	window.requestAnimationFrame(scrollHandler);
	window.requestAnimationFrame(resizeHandler);

	// hide success alert
	if ( $('.alert-success').length ) {
		setTimeout(function(){
			$('.alert-success').slideUp();
		}, 4000);
	}

	$('.form_style :required').prev('label').addClass('required');

	// STYLED SELECT BOXES //
	$('.form_style select, .styled_select').each(function(){
		if (!$(this).parent().hasClass('select_wrapper')) {
			$(this).wrap('<div class="select_wrapper"></div>');
		}
	});

	$('#filter').on('change', function () {
		var the_name = $(this).attr('name');
		var the_value = $(this).val();
		var destination = window.location.pathname;
		if (the_value != '') {
			destination += '?' + the_name + '=' + the_value;
		}
		window.location.href = destination;
	});

	$('#sort').on('change', function () {
		var the_value = $(this).val();
		$('#search_form input[name="sort"]').val(the_value);
		$('#search_form').submit();
	});

	// RESPONSIVE VIDEO
	allVideos = $("iframe[src^='https://www.youtube'], iframe[src^='//www.youtube'], iframe[src^='https://player.vimeo.com'], iframe[src^='//player.vimeo.com']").not('.notfluid');
	// Figure out and save aspect ratio for each video
	allVideos.each(function() {

		var the_width = $(this).width();
		var the_height = $(this).height();

			$(this)
			.attr('data-aspectratio', the_height / the_width)
			.attr('data-maxwidth', the_width)
			.attr('data-maxheight', the_height)
			.css('margin-bottom','calc(2vw + 2.0rem)')
			.css('max-width','100%');

	});
	fluidVideos();

	$('.video video').click(function () {
		if (this.paused) {
			$(this).parent().removeClass('paused').addClass('playing');
			this.play();
			this.addEventListener('ended', function () {
				$(this).parent().addClass('paused').removeClass('playing');
			},false);
    	} else {
			$(this).parent().addClass('paused').removeClass('playing');
			this.pause();
		}
	});

	$('.map_element').each(function () {
		initMap($(this));
	});

	$('.page_banner .slides').slick({
		adaptiveHeight: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        swipe: true,
        draggable: true,
        fade: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 1000,
		pauseOnHover: false,
        arrows: false,
        dots: false,
        cssEase: 'ease-in-out',
		rows: 0,
	});

    $('.listing.carousel').on('init', function(event, slick){
		slick.slickSetOption('autoplay', $(this).hasClass('auto'));
	}).slick({
        adaptiveHeight: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        swipeToSlide: true,
        swipe: true,
        draggable: true,
        fade: false,
        infinite: false,
		autoplay: false,
		autoplaySpeed: 4000,
		pauseOnHover: true,
        speed: 1000,
        arrows: true,
        dots: false,
        cssEase: 'ease-in-out',
		rows: 0,
		prevArrow: "<button type='button' class='slick-prev'><i class='fal fa-chevron-left' aria-hidden='true'></i><span>Previous</span></button>",
        nextArrow: "<button type='button' class='slick-next'><i class='fal fa-chevron-right' aria-hidden='true'></i><span>Next</span></button>",
		responsive: [,
            {
                breakpoint: 551,
                settings: {
					slidesToShow: 1,
					arrows: false,
					dots: true,
					infinite: true
                }
            },
        ]
    });

	$('.awards.carousel').slick({
        adaptiveHeight: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        swipeToSlide: false,
        swipe: false,
        draggable: false,
        fade: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 6000,
        arrows: false,
        dots: false,
        cssEase: 'linear',
		rows: 0,

		responsive: [,
            {
                breakpoint: 651,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 451,
                settings: {
					slidesToShow: 2,
                }
            },
        ]
    });

	$('.testimonials.carousel').slick({
        adaptiveHeight: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        swipeToSlide: true,
        swipe: true,
        draggable: true,
        fade: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 1000,
        arrows: true,
        dots: false,
        cssEase: 'ease-in-out',
		rows: 0,
		prevArrow: "<button type='button' class='slick-prev'><i class='fal fa-chevron-left' aria-hidden='true'></i><span>Previous</span></button>",
        nextArrow: "<button type='button' class='slick-next'><i class='fal fa-chevron-right' aria-hidden='true'></i><span>Next</span></button>",
		responsive: [,
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 551,
                settings: {
					slidesToShow: 1,
					arrows: false,
					dots: true,
                }
            },
        ]
    });

	$(document).on('change', '#branch_select', function () {
		$el = $("#area_select");
		$el.empty();
		$sel = $("option:selected", $(this));
		$el.append($("<option />").val('').text('Any'));
		var options = $sel.data('areas');
		$.each(options, function () {
			$el.append($("<option />").val(this).text(this));
		});
	});

	$('.property_tabs li').on("click", function () {
		$('.property_tabs li').removeClass('active');
		$(this).addClass("active");
		var tab = $(this).data('tab');
		$('.property_tab').hide();
		$('#' + tab).show();
	});

	$('.read_more').each(function () {
		var el = $(this);
		var c_count = el.text().length; // count of characters
		var p_count = el.find("p").length; // count of paragraphs
		var pc_count = el.find("p:lt(2)").text().length; // count of characts in the first two paragraphs
		// if there are more than 2 paragraphs then hide everything after, unless there isn't much content remaining
		if (p_count > 2 && c_count > pc_count * 1.2) {
			el.addClass('truncatable').addClass('hidden');
		} else {
			el.addClass('show_all');
		}
		$('button', this).html('');
	});
	$('.read_more button').on('click', function () {
		$(this).parent().toggleClass('hidden').toggleClass('visible')
	});

	jconfirm.defaults = {
		draggable: false,
		useBootstrap: false,
		boxWidth: '50rem',
		type: 'primary',
		typeAnimated: false
	};

	$('#alertexample').click(function () {
		$.alert({
			title: 'Great!',
			content: 'This is a demo alert',
			buttons: {
				Cancel: {
					text: 'Cancel',
					action: function () {

					}
				},
				OK: {
					text: 'Continue',
					btnClass: 'btn-primary',
					action: function () {

					}
				}
			}
		});
	});

    $.featherlight.defaults.afterContent = function () {
        $('.featherlight-content').find('a, input[type!="hidden"], select, textarea, iframe, button:not(.featherlight-close), iframe, [contentEditable=true]').each(function (index) {
            if (index === 0) {
                $(this).prop('autofocus', true);
            }
            $(this).prop('tabindex', 0);
		});
		if ($('.featherlight-content').find('.g-recaptcha').length > 0) {
			var captchaContainer = null;
			var loadCaptcha = function () {
				$('.featherlight-content').find('.g-recaptcha').each(function () {
					var element = $(this);
					captchaContainer = grecaptcha.render(element[0], {
						'sitekey' : element.data('sitekey'),
						'callback' : function(response) {
						}
					});
				});
			};
			loadCaptcha(); // THIS LINE WAS MISSING
		}
    };

	// DO NOT CHANGE - trigger function when window scrolls
	$(window).scroll(function () {
		window.requestAnimationFrame(scrollHandler);
	});

	// DO NOT CHANGE - trigger function when window resizes
	$(window).resize(function() {
		window.requestAnimationFrame(resizeHandler);
	});

	// DO NOT CHANGE - trigger function when mouse moves
	$(document).on('mousemove',function(e){
		xpos = e.clientX;
		ypos = e.clientY;
		window.requestAnimationFrame(mouseHandler);
    });

	function resizeHandler() {
		viewportWidth = window.innerWidth;
		doPropertyCall2Action();
	}

});

function scrollHandler() {
	var topOfViewport = $(window).scrollTop();
	var bottomOfViewport = topOfViewport + $(window).height();
	doPropertyCall2Action();
}

function doPropertyCall2Action() {
	var window_height = $(window).outerHeight();
	var el_height = $('.property_call_to_action > div').outerHeight();
	var share_height = $('#st-1').outerHeight();
	if ($('.property_call_to_action').css('position') == 'sticky') {
		if ($('#st-1').css('display') != 'flex') { share_height = 0; }
		$('.property_call_to_action').css('top', Math.round(window_height - el_height - share_height + 1) + 'px');
		$('.property_call_to_action').parent().css('padding-bottom', Math.round(el_height - 2) + 'px');
	} else {
		$('.property_call_to_action').css('top', 0);
		$('.property_call_to_action').parent().css('padding-bottom', 0);
	}
}

function mouseHandler() {
}

function fluidVideos() {
	// Resize all videos according to their own aspect ratio
	allVideos.each(function() {
		var $el = $(this);
		var newWidth = $(this).parent().width();
		$el
			.width(newWidth)
			.height(newWidth * $el.data('aspectratio'));
	});
}

$(() => {
    const stuckClass = 'stuck';
    const $stickyTopElements = $('header');

    const determineSticky = () => {
        $stickyTopElements.each((i, el) => {
            const $el = $(el);
            const currTop = $(window).scrollTop();

            if (viewportWidth <= 1.024) {
                $el.removeClass(stuckClass);
			} else {
                if ($el.hasClass(stuckClass) && currTop == 0 ) {
                    $el.removeClass(stuckClass);
                }
                if (!$el.hasClass(stuckClass) && currTop > 0) {
                    $el.addClass(stuckClass);
                }
            }
        });
	};

    //Run when the browser is resized or scrolled
    $(window).on('load onpageshow resize scroll', () => {
        determineSticky();
    });
    if (document.readyState === "complete") {
        determineSticky();
    }
});

function initMap($element) {
	var the_center;
	var lat = parseFloat($element.data('latitude'));
	var lng = parseFloat($element.data('longitude'));
	var zoom = parseInt($element.data('zoom'));
	var style = $element.data('style');
	var the_center = { lat: lat, lng: lng };
	if (style == 'dark') {
		var style_data = [{ "featureType": "all", "elementType": "all", "stylers": [{ "hue": "#ff0000" }, { "saturation": -100 }, { "lightness": -30 }] }, { "featureType": "all", "elementType": "labels.text.fill", "stylers": [{ "color": "#ffffff" }] }, { "featureType": "all", "elementType": "labels.text.stroke", "stylers": [{ "color": "#353535" }] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [{ "color": "#545654" }] }, { "featureType": "poi", "elementType": "geometry.fill", "stylers": [{ "color": "#424646" }] }, { "featureType": "poi", "elementType": "geometry.stroke", "stylers": [{ "color": "#ffff00" }] }, { "featureType": "road", "elementType": "geometry", "stylers": [{ "color": "#323434" }] }, { "featureType": "transit", "elementType": "labels", "stylers": [{ "hue": "#000000" }, { "saturation": 100 }, { "lightness": -40 }, { "invert_lightness": true }, { "gamma": 1.5 }] }];
		var icon = {
			url: '/images/map-marker.svg',
			scaledSize: new google.maps.Size(48, 64),
		}
	} else {
		var style_data = null;
		var icon = null;
	}

	var map = new google.maps.Map($element[0], {
		zoom: zoom,
		center: the_center,
		scrollwheel: false,
		mapTypeControl: false,
		draggable: true,
		streetViewControl: false,
		zoomControl: true,
		panControl: false,
		mapTypeId: google.maps.MapTypeId.ROADMAP,
		styles: style_data
	});


	var marker = new google.maps.Marker({
		position: the_center,
		map: map,
		icon: icon

	});
	google.maps.event.addDomListener(window, 'resize', function() {
		mapcenter(map, the_center);
	});
}

function mapcenter(map, the_center) {
	map.setCenter(new google.maps.LatLng(
		the_center
	));
}
